var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"table-caption"},[_vm._v("Operadores")]),_vm._v(" "),[_c('div',[_c('b-card',[_c('Grid',{attrs:{"name":"OperatorsGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"pagesize":_vm.pagesize,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c050bc1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operators/operatorsGrid.vue
// module id = 941
// module chunks = 1